<template>
  <b-card>
    <b-link :to="{ name: 'arena-lesson-detail', params: { lesson_id: lesson._id } }">
      <b-img class="w-100" :src="lesson.thumbnail.value" v-if="lesson.thumbnail.value" />
      <b-img v-else :blank="true" blank-color="#ccc" alt="placeholder" height="172" class="w-100" />
      <h3 class="mt-1 mb-0 text-truncate-2" style="height: 2.7em">{{ lesson.title || lesson._id }} </h3>
      <small class="d-block mt-50" style="color: #bbb">
        Last edited: {{ lesson.updatedAt | local_time_string }}
      </small>
    </b-link>
  </b-card>
</template>

<script>
export default {
  props: {
    lesson: { type: Object, required: true },
  },
}
</script>
